






import { Vue } from "vue-property-decorator";

export default class Index extends Vue {
}
